module.exports = __webpack_public_path__ + "static/biko-674706a9f7eb9d78c625506c55982825.jpg";